module.exports = __webpack_public_path__ + "static/img/b1-2-1.da62c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-2-1.png
// module id = 0QkH
// module chunks = 1